// es-ES
export default {
	title: "Centro de Tarjetas de Regalo",
	myPoints: "Mis Puntos",
	SelectedGifts: "Regalos Seleccionados",
	form: {
		label: {
			title: "Buscar",
			points: "Puntos"
		}
	},
	redemption: "Redención",
	stock: "Existencias",
	id: {
		redeemPoints: "Canjear los puntos necesarios:",
		btn: "Canjear ahora",
		title: "Aviso de Compra",
		content: `Estimado trabajador, gracias por su participación en el trabajo.\n\nLea los siguientes términos antes de canjear puntos:\n\n[Puntos de trabajo] Después de completar diariamente la optimización de los datos del conjunto de pedidos, los trabajadores pueden ganar 1 punto de regalo, que puede se utilizará para el canje parcial del patrocinio de obsequios.\n[Canje de obsequios] Los trabajadores deben proporcionar información relevante sobre la dirección de envío y el obsequio se enviará sin cargo a todo el mundo dentro de los 14 días. Una vez completado el canje, puede comunicarse con el servicio de atención al cliente para obtener el número de seguimiento y seguir el progreso del regalo. La plataforma no revelará información a terceros.\nNota: Una vez que los puntos se canjean por regalos, no se pueden reembolsar`
	},
	applyDialog: {
		title: "Recepción de información",
		form: {
			consignee: "Destinatario",
			area: "Área",
			telephone: "Teléfono",
			deliveryAddress: "Dirección de entrega"
		},
		btn: "Enviar a"
	},
	records: {
		title: "Registros",
		status: ["Esperando envío", "Enviado", "Entregado", "Cancelado"]
	}
};
